import React, { useEffect, useState } from "react";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";

import { useParams } from "react-router-dom";
import {
  FaStar,
  FaHeart,
  FaRegHeart,
  FaMinus,
  FaPlus,
  FaShoppingBag,
  FaBolt,
  FaTruck,
  FaShieldAlt,
  FaUndoAlt,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import "./ProductDetails.css";

function ProductDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cartMessage, setCartMessage] = useState("");
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [wishlist, setWishlist] = useState(false);

useEffect(() => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  scrollToTop();

  // Browser/React Router ke scroll restoration ko override karega
  requestAnimationFrame(() => {
    scrollToTop();
  });

  setTimeout(() => {
    scrollToTop();
  }, 50);
}, [id]);
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/products/${id}`
        );

        const data = await response.json();

        if (data.success) {
          setProduct(data.product);
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProduct();
  }, [id]);

  /* 
     IMAGE URL
   */

  const imageUrl = (image) => {
    if (!image) return "";

    if (image.startsWith("http")) {
      return image;
    }

   return `${API_BASE_URL}/${image.replace(/^\/+/, "")}`;
  };

  /* 
     DESCRIPTION FORMATTER
   */

  const formatDescription = (description) => {
    const text =
      description ||
      "A refined expression of modern watchmaking, designed for those who appreciate timeless details, exceptional finishing and effortless sophistication.";

    const importantPhrases = [
      "precision",
      "premium",
      "stainless steel",
      "scratch resistant",
      "water resistant",
      "water resistance",
      "quartz",
      "automatic",
      "genuine",
      "authentic",
      "timeless",
      "exceptional finishing",
      "refined",
      "sophistication",
      "comfortable strap",
      "premium experience",
    ];

    const escapeRegex = (value) =>
      value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const pattern = new RegExp(
      `(${importantPhrases
        .sort((a, b) => b.length - a.length)
        .map(escapeRegex)
        .join("|")})`,
      "gi"
    );

    return text.split(/(\.|!|\?|\n)/).map((part, index) => {
      if (/^[.!?]$/.test(part)) {
        return <React.Fragment key={index}>{part}</React.Fragment>;
      }

      return (
        <React.Fragment key={index}>
          {part.split(pattern).map((chunk, chunkIndex) =>
            importantPhrases.some(
              (phrase) => phrase.toLowerCase() === chunk.toLowerCase()
            ) ? (
              <strong key={chunkIndex}>{chunk}</strong>
            ) : (
              <React.Fragment key={chunkIndex}>{chunk}</React.Fragment>
            )
          )}
        </React.Fragment>
      );
    });
  };

  /* 
     LOADING
   */

  if (loading) {
    return (
      <div className="tv-product-details-loading">
        <span>Loading watch...</span>
      </div>
    );
  }

  /* 
     PRODUCT NOT FOUND
   */

  if (!product) {
    return (
      <div className="tv-product-details-loading">
        <span>Product not found</span>
      </div>
    );
  }

  /* 
     PRODUCT IMAGES
   */

const productImages = [
  product.image1,
  product.image2,
  product.image3,
  product.image4,
].filter(Boolean);



  /* 
     REVIEWS
    
   */

  const reviews = [
    {
      id: 1,
      name: "Daniel Morgan",
      avatar: "https://i.pravatar.cc/100?img=12",
      rating: 5,
      date: "2 weeks ago",
      text:
        "Absolutely beautiful watch. The finishing is exceptional and it feels far more premium than I expected. The attention to detail is impressive.",
    },
    {
      id: 2,
      name: "Oliver James",
      avatar: "https://i.pravatar.cc/100?img=11",
      rating: 5,
      date: "1 month ago",
      text:
        "The watch looks even better in person. Elegant, comfortable and perfect for both formal and everyday wear. Delivery was also excellent.",
    },
    {
      id: 3,
      name: "Ethan Williams",
      avatar: "https://i.pravatar.cc/100?img=13",
      rating: 4,
      date: "2 months ago",
      text:
        "A very refined timepiece. The dial catches the light beautifully and the strap feels comfortable throughout the day.",
    },
  ];

  return (
    <main className="tv-product-details">
   
      {/* =================================================
          PRODUCT MAIN SECTION
      ================================================= */}

      <div className="tv-product-details-container">
{cartMessage && (
  <div className="tv-cart-toast">
    <span className="tv-cart-toast-check">✓</span>

    <div>
      <strong>Added to Cart</strong>
      <p>{cartMessage}</p>
    </div>

    <button
      type="button"
      onClick={() => navigate("/cart")}
    >
      VIEW CART
    </button>
  </div>
)}
        {/* ================= IMAGE GALLERY ================= */}

        <div className="tv-product-gallery">

          <div className="tv-product-main-image">

            {productImages.length > 1 && (
              <button
                className="tv-gallery-arrow tv-gallery-prev"
                onClick={() =>
                  setSelectedImage(
                    selectedImage === 0
                      ? productImages.length - 1
                      : selectedImage - 1
                  )
                }
              >
                <FaChevronLeft />
              </button>
            )}

          <img
  src={imageUrl(productImages[selectedImage])}
  alt={product.name}
  width="900"
  height="1200"
  loading="eager"
  fetchPriority="high"
  decoding="async"
/>

            {product.tag && (
              <span className="tv-product-image-tag">
                {product.tag}
              </span>
            )}

            {productImages.length > 1 && (
              <button
                className="tv-gallery-arrow tv-gallery-next"
                onClick={() =>
                  setSelectedImage(
                    selectedImage === productImages.length - 1
                      ? 0
                      : selectedImage + 1
                  )
                }
              >
                <FaChevronRight />
              </button>
            )}

          </div>

          {/* THUMBNAILS */}

          {productImages.length > 1 && (
            <div className="tv-product-thumbnails">

              {productImages.map((image, index) => (
                <button
                  key={index}
                  className={`tv-product-thumbnail ${
                    selectedImage === index ? "active" : ""
                  }`}
                  onClick={() => setSelectedImage(index)}
                >
                 <img
  src={imageUrl(image)}
  alt={`${product.name} ${index + 1}`}
  width="120"
  height="160"
  loading="eager"
  decoding="async"
/>
                </button>
              ))}

            </div>
          )}
<div className="tv-product-specs">
            <div className="tv-specs-heading">
              <div>
                <span>TIME VALLEY</span>
                <strong>WATCH DETAILS</strong>
              </div>
              <i></i>
            </div>

            <div className="tv-spec-item">
              <span>Movement</span>
              <strong>Precision Quartz</strong>
            </div>

            <div className="tv-spec-item">
              <span>Case</span>
              <strong>Premium Stainless Steel</strong>
            </div>

            <div className="tv-spec-item">
              <span>Glass</span>
              <strong>Scratch Resistant</strong>
            </div>

            <div className="tv-spec-item">
              <span>Water Resistance</span>
              <strong>5 ATM</strong>
            </div>

          </div>

        </div>
        

        {/* ================= PRODUCT INFO ================= */}

        <div className="tv-product-details-info">

          <div className="tv-product-brand">
            TIME VALLEY
          </div>

          {product.tag && (
            <span className="tv-product-details-tag">
              {product.tag}
            </span>
          )}

          <h1>{product.name}</h1>

          {/* RATING */}

          <div className="tv-product-rating">

            <div className="tv-stars">
              <FaStar />
              <FaStar />
              <FaStar />
              <FaStar />
              <FaStar />
            </div>

            <span>4.9</span>

            <a href="#reviews">
              127 Reviews
            </a>

          </div>

          <div className="tv-product-details-line"></div>

          {/* PRICE */}

         <div className="tv-product-price-wrapper">

  {product.top_price &&
    Number(product.top_price) > Number(product.price) && (
      <div className="tv-product-original-row">
        <span className="tv-product-original-price">
          Rs {Number(product.top_price).toLocaleString()}
        </span>

        <span className="tv-product-discount">
          {Math.round(
            ((Number(product.top_price) - Number(product.price)) /
              Number(product.top_price)) *
              100
          )}
          % OFF
        </span>
      </div>
    )}

  <div className="tv-product-details-price">
    Rs {Number(product.price || 0).toLocaleString()}
  </div>

  <span className="tv-price-note">
    Reasonable Price
  </span>

</div>

          {/* DESCRIPTION */}

          <div className="tv-product-description-block">
            <div className="tv-description-heading">
              <span>ABOUT THE WATCH</span>
              <i></i>
            </div>

            <p className="tv-product-details-description">
              {formatDescription(product.description)}
            </p>
          </div>

          {/* PREMIUM INTRO */}

          <div className="tv-product-short-story">

            <span>THE TIME VALLEY STANDARD</span>

            <p>
              Crafted with a focus on precision, balance and timeless
              aesthetics, this timepiece is designed to become part of
              your everyday story. From its carefully finished dial to
              its refined case and comfortable strap, every detail has
              been considered to deliver a distinctly premium experience.
            </p>

          </div>

        
          {/* QUANTITY */}

      <div className="tv-product-purchase">

  <div className="tv-quantity-wrapper">

    <span className="tv-quantity-label">
      QUANTITY
    </span>

   <div className="tv-quantity">
  <button
    type="button"
    onClick={() =>
      setQuantity((prev) => Math.max(1, prev - 1))
    }
    aria-label="Decrease quantity"
  >
    <FaMinus />
  </button>

  <span className="tv-quantity-number">
    {quantity}
  </span>

  <button
    type="button"
    onClick={() =>
      setQuantity((prev) => Math.min(5, prev + 1))
    }
    aria-label="Increase quantity"
  >
    <FaPlus />
  </button>
</div>

  </div>

  <button
    className="tv-add-cart-button"
    onClick={() => {
      addToCart(product, quantity);

      setCartMessage(
        `${product.name} added to your cart`
      );

      setTimeout(() => {
        setCartMessage("");
      }, 2500);
    }}
  >
    <FaShoppingBag />
    ADD TO CART
  </button>

  <button
    className="tv-wishlist-button"
    onClick={() => setWishlist(!wishlist)}
  >
    {wishlist ? <FaHeart /> : <FaRegHeart />}
  </button>

</div>

       <button
  className="tv-buy-now-button"
  onClick={() =>
    navigate("/customer-details", {
      state: {
        product,
        quantity,
      },
    })
  }
>
  <FaBolt />
  BUY NOW
</button>

          {/* BENEFITS */}

          <div className="tv-product-benefits">

            <div className="tv-benefit">
              <FaTruck />
              <div>
                <strong>Complimentary Delivery</strong>
                <span>Delivered with care</span>
              </div>
            </div>

            <div className="tv-benefit">
              <FaShieldAlt />
              <div>
                <strong>Authenticity Guaranteed</strong>
                <span>Genuine Time Valley timepiece</span>
              </div>
            </div>

            <div className="tv-benefit">
              <FaUndoAlt />
              <div>
                <strong>Easy Returns</strong>
                <span>Shop with complete confidence</span>
              </div>
            </div>

          </div>

        </div>
      </div>

      {/* =================================================
          DETAILS STORY
      ================================================= */}

      <section className="tv-product-story">

        <div className="tv-product-story-inner">

          <div className="tv-story-heading">

            <span>THE DETAILS</span>

            <h2>
              Designed to be
              <em> remembered.</em>
            </h2>

          </div>

          <div className="tv-story-content">

            <p>
              A watch is more than an instrument that tells time.
              It is an expression of character, a quiet detail that
              completes the way you present yourself to the world.
            </p>

            <p>
              This Time Valley timepiece brings together contemporary
              proportions and timeless watchmaking aesthetics. Its
              balanced dial, refined case and carefully selected
              materials create a piece that feels equally at home
              at an evening occasion or during an everyday moment.
            </p>

            <p>
              Every element has been considered to create a watch
              that does not simply follow trends, but remains elegant
              long after they have passed.
            </p>

          </div>

        </div>

      </section>

      {/* =================================================
          REVIEWS
      ================================================= */}

      <section
        className="tv-product-reviews"
        id="reviews"
      >

        <div className="tv-product-reviews-container">

          <div className="tv-reviews-heading">

            <span>CLIENT IMPRESSIONS</span>

            <h2>
              Loved by those
              <em> who wear it.</em>
            </h2>

          </div>

          {/* REVIEW SUMMARY */}

          <div className="tv-review-summary">

            <div className="tv-review-score">
              <strong>4.9</strong>

              <div className="tv-stars">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
              </div>

              <span>Based on 127 reviews</span>
            </div>

            <div className="tv-review-bars">

              <div>
                <span>5</span>
                <div className="tv-review-bar">
                  <i style={{ width: "94%" }}></i>
                </div>
              </div>

              <div>
                <span>4</span>
                <div className="tv-review-bar">
                  <i style={{ width: "5%" }}></i>
                </div>
              </div>

              <div>
                <span>3</span>
                <div className="tv-review-bar">
                  <i style={{ width: "1%" }}></i>
                </div>
              </div>

            </div>

          </div>

          {/* REVIEWS */}

          <div className="tv-reviews-list">

            {reviews.map((review) => (
              <article
                className="tv-review-card"
                key={review.id}
              >

                <div className="tv-review-user">

                  <img
                    src={review.avatar}
                    alt={review.name}
                  />

                  <div>
                    <strong>{review.name}</strong>

                    <span>{review.date}</span>
                  </div>

                </div>

                <div className="tv-review-stars">

                  {[...Array(5)].map((_, index) => (
                    <FaStar
                      key={index}
                      className={
                        index < review.rating
                          ? "active"
                          : ""
                      }
                    />
                  ))}

                </div>

                <p>
                  "{review.text}"
                </p>

                <small>
                  ✓ Verified Purchase
                </small>

              </article>
            ))}

          </div>

        </div>

      </section>

    </main>
  );
}

export default ProductDetails;